module.exports = __webpack_public_path__ + "media/components/shared/static/triangle_up-cb3f59f6d1e6a1a34a9b29ef30c0eec7.svg";